import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { FormControl, FormControlLabel, RadioGroupProps, Radio, RadioGroup, InputLabel } from '@mui/material';

interface FormRadioGroupProps<T extends FieldValues> extends Omit<RadioGroupProps, 'name'> {
  name: Path<T>;
  control: Control<T, any, any>;
  options: Array<{ label: string; value: string | number }>;
  label?: string;
  testId?: string;
}

export const FormRadioGroup = <T extends FieldValues>({
  name,
  control,
  options,
  label,
  testId,
  ...radioGroupProps
}: FormRadioGroupProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} fullWidth data-rhf-field={String(name)}>
          {label && <InputLabel>{label}</InputLabel>}

          <RadioGroup
            row
            value={field.value}
            name="radio-buttons-group"
            data-testid={testId}
            onChange={e => {
              field.onChange(e.target.value);
            }}
            {...radioGroupProps}
          >
            {options.map(option => (
              <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={option.label} />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};
